module.exports = __webpack_public_path__ + "components/country-flag/static/et-fad121416a20720f6aa1c1019003ecf0.svg";